import * as React from "react";

const SignalQuality = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 -960 960 960">
      <path d="M120-120v-80l80-80v160zm160 0v-240l80-80v320zm160 0v-320l80 81v239zm160 0v-239l80-80v319zm160 0v-400l80-80v480zM120-327v-113l280-280 160 160 280-280v113L560-447 400-607z"></path>
    </svg>
  );
};

export default SignalQuality;
